import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FileClock } from "lucide-react";
import { api } from "@/lib/api";

const quand = (j) => (j > 0 ? `dans ${j} jours` : j === 0 ? "aujourd'hui" : `échu depuis ${-j} jours`);

export const BauxBanner = ({ refreshKey }) => {
  const [baux, setBaux] = useState([]);
  const [tal, setTal] = useState([]);
  const [taux, setTaux] = useState(null);
  useEffect(() => {
    api.get("/baux/alertes").then((r) => setBaux(r.data)).catch(() => {});
    api.get("/baux/tal").then((r) => setTal(r.data)).catch(() => {});
    api.get("/tal/taux").then((r) => setTaux(r.data.courant.provisoire ? r.data.annee : null)).catch(() => {});
  }, [refreshKey]);
  if (!baux.length && !tal.length && !taux) return null;
  return (
    <div className="mb-6 rounded-lg border border-amber-300 bg-amber-50 p-4 sm:p-5 rise" data-testid="baux-banner">
      <div className="flex items-start gap-3">
        <FileClock className="h-5 w-5 mt-0.5 shrink-0 text-amber-600" />
        <div className="flex-1">
          {taux && <p className="mb-1 text-sm font-semibold" data-testid="taux-tal-alerte">Taux de base {taux} du TAL à saisir <Link to="/parametres" className="ml-1 text-xs font-medium text-emerald-700 hover:underline">Paramètres</Link></p>}
          {baux.length > 0 && <p className="text-sm font-semibold">Baux à renouveler ({baux.length})</p>}
          <ul className="mt-1 space-y-0.5 text-xs text-slate-700">
            {baux.map((b) => (
              <li key={b.id} data-testid={`bail-alerte-${b.id}`}><b>{b.nom}</b> · {b.logement} · fin le {b.bail_fin} ({quand(b.jours)})</li>
            ))}
          </ul>
          {tal.length > 0 && <>
            <p className="mt-2 text-sm font-semibold text-red-700">Demandes au TAL à déposer ({tal.length})</p>
            <ul className="mt-1 space-y-0.5 text-xs text-slate-700">{tal.map((t) => <li key={t.id} data-testid={`tal-alerte-${t.id}`}><b>{t.nom}</b> · {t.logement} · hausse refusée, date limite le {t.limite} ({t.jours} jours)</li>)}</ul>
          </>}
          <Link to="/commentaires" className="mt-2 inline-block text-xs font-medium text-emerald-700 hover:underline" data-testid="baux-banner-lien">Voir les locataires</Link>
        </div>
      </div>
    </div>
  );
};
